import { useParams } from 'react-router-dom';
import SmallLoader from '@/src/Common/components/SmallLoader';
import EventDashboardFrame from './EventDashboardFrame';
import CreateEventStepTwo from './CreateEventStepTwo';
import { useEventExperience } from './hooks/useEventExperience';
import { Button } from '@/src/tailwindui/button';
import { toast } from 'sonner';
import { useRef } from 'react';

export default function EditExperience() {
    const { activationId } = useParams();
    const {
        experience,
        isLoading,
        experienceTemplates,
        processingFlowTemplates,
        templateValues,
        setExperience,
        setProcessingFlowTemplate,
        setTemplateValues,
        recordValues,
        platform,
        processingFlowTemplate,
        saveExperience,
    } = useEventExperience(Number(activationId));

    const isSaving = useRef(false);
    if (isLoading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <SmallLoader />
            </div>
        );
    }

    return (
        <EventDashboardFrame
            navLocation="experience"
            activationId={activationId || ''}
        >
            <div className="flex flex-row gap-4 items-end h-[50px] justify-end mt-2">
                <div className="flex flex-col items-end justify-end ">
                    <Button
                        className="text-sm dark-button"
                        onClick={() => {
                            setTemplateValues({});
                            setExperience(null);
                            setProcessingFlowTemplate(null);
                        }}
                    >
                        Change {platform === 'romr' ? 'Output' : 'Experience'}{' '}
                        Type
                    </Button>
                </div>
            </div>
            <CreateEventStepTwo
                experience={experience}
                setExperience={setExperience}
                experienceTemplates={experienceTemplates}
                platform={platform}
                recordValues={recordValues}
                processingFlowTemplate={processingFlowTemplate}
                setProcessingFlowTemplate={setProcessingFlowTemplate}
                processingFlowTemplates={processingFlowTemplates}
                templateValues={templateValues}
                setTemplateValues={setTemplateValues}
                onNext={async () => {
                    if (isSaving.current) return;
                    isSaving.current = true;
                    try {
                        await saveExperience();
                        toast.success('Experience updated successfully');
                    } catch (error) {
                        console.error('Error saving experience', error);
                        toast.error('Error saving experience');
                    } finally {
                        isSaving.current = false;
                    }
                }}
                buttonText="Save"
            />
        </EventDashboardFrame>
    );
}
